import {SalesRepositoryImpl} from '../repository/SalesRepositoryImpl';
import {GetSalesUseCase} from '../useCases/GetSalesUseCase';
import {GetSalesWithFiltersUseCase} from '../useCases/GetSalesWithFiltersUseCase';
import {GetSalesStatisticsUseCase} from '../useCases/GetSalesStatisticsUseCase';
import {GetSaleByIdUseCase} from '../useCases/GetSaleByIdUseCase';
import {GetSaleByInvoiceNumberUseCase} from '../useCases/GetSaleByInvoiceNumberUseCase';
import {UpdateSaleUseCase} from '../useCases/UpdateSaleUseCase';
import {DeleteSaleUseCase} from '../useCases/DeleteSaleUseCase';
import {useSalesStore} from './salesStore';

class SalesFactory {
  private static instance: SalesFactory;
  private salesRepository: SalesRepositoryImpl;
  private getSalesUseCase: GetSalesUseCase;
  private getSalesWithFiltersUseCase: GetSalesWithFiltersUseCase;
  private getStatisticsUseCase: GetSalesStatisticsUseCase;
  private getSaleByIdUseCase: GetSaleByIdUseCase;
  private getSaleByInvoiceNumberUseCase: GetSaleByInvoiceNumberUseCase;
  private updateSaleUseCase: UpdateSaleUseCase;
  private deleteSaleUseCase: DeleteSaleUseCase;

  private constructor () {
    this.salesRepository = new SalesRepositoryImpl();
    this.getSalesUseCase = new GetSalesUseCase(this.salesRepository);
    this.getSalesWithFiltersUseCase = new GetSalesWithFiltersUseCase(this.salesRepository);
    this.getStatisticsUseCase = new GetSalesStatisticsUseCase(this.salesRepository);
    this.getSaleByIdUseCase = new GetSaleByIdUseCase(this.salesRepository);
    this.getSaleByInvoiceNumberUseCase = new GetSaleByInvoiceNumberUseCase(this.salesRepository);
    this.updateSaleUseCase = new UpdateSaleUseCase(this.salesRepository);
    this.deleteSaleUseCase = new DeleteSaleUseCase(this.salesRepository);
  }

  static getInstance (): SalesFactory {
    if (!SalesFactory.instance) {
      SalesFactory.instance = new SalesFactory();
    }
    return SalesFactory.instance;
  }

  getSalesUseCaseInstance () {
    return this.getSalesUseCase;
  }

  getSalesWithFiltersUseCaseInstance () {
    return this.getSalesWithFiltersUseCase;
  }

  getStatisticsUseCaseInstance () {
    return this.getStatisticsUseCase;
  }

  getSaleByIdUseCaseInstance () {
    return this.getSaleByIdUseCase;
  }

  getSaleByInvoiceNumberUseCaseInstance () {
    return this.getSaleByInvoiceNumberUseCase;
  }


  getUpdateSaleUseCaseInstance () {
    return this.updateSaleUseCase;
  }

  getDeleteSaleUseCaseInstance () {
    return this.deleteSaleUseCase;
  }


  // Initialize store with use cases
  initializeStore () {
    const store = useSalesStore.getState();
    (store as any).getSalesUseCase = this.getSalesUseCase;
    (store as any).getSalesWithFiltersUseCase = this.getSalesWithFiltersUseCase;
    (store as any).getStatisticsUseCase = this.getStatisticsUseCase;
    (store as any).getSaleByIdUseCase = this.getSaleByIdUseCase;
    (store as any).getSaleByInvoiceNumberUseCase = this.getSaleByInvoiceNumberUseCase;
    (store as any).updateSaleUseCase = this.updateSaleUseCase;
    (store as any).deleteSaleUseCase = this.deleteSaleUseCase;
  }
}

export const salesFactory = SalesFactory.getInstance();
